const localizers = {
  'Alerts.noAlerts.txt': () => `没有为该报表设置提醒。`,
  'BirdImage.image.txt': () => `图像`,
  'BirdText.editable.tooltip.txt': () => `双击以编辑文本`,
  'ComboBox.clearFilter.txt': () => `清除过滤器`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue}（无数据）`,
  'ContextMenu.selectAll.txt': () => `全选`,
  'ContextMenu.clearSelection.txt': () => `清除选择`,
  'ContextMenu.exportImage.txt': () => `导出为图像`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: 升序`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: 降序`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: 添加升序`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: 添加降序`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `从排序中移除“${role}”`,
  'ContextMenu.removeSortLevel.txt': () => `移除排序级别`,
  'ContextMenu.sort.txt': () => `排序`,
  'ContextMenu.selectShortestPath.txt': () => `选择最短路径`,
  'ContextMenu.explain.txt': () => `解释数据`,
  'ContextMenu.explainRole.txt': ({role}) => `解释“${role}”...`,
  'ContextMenu.manageColumns.txt': () => `管理列`,
  'ContextMenu.includeMissingValues.txt': () => `包括缺失值`,
  'DrillableTooltip.drill.txt': () => `钻取`,
  'DrillableTooltip.tooltip.txt': () => `工具提示`,
  'DrillableTooltip.links.txt': () => `链接`,
  'DrillableTooltip.section.link.fmt': ({page}) => `指向“${page}”的页面链接`,
  'DrillableTooltip.report.link.fmt': ({report}) => `指向“${report}”的报表链接`,
  'DrillableTooltip.external.link.fmt': ({url}) => `指向“${url}”的外部链接`,
  'DrillableTooltip.notAvailable.txt': () => `不可用`,
  'Breadcrumb.all.fmt': ({label}) => `全部“${label}”`,
  'BrowserCheck.title.txt': () => `WebGL 检查`,
  'BrowserCheck.msg.txt': () => `WebGL 已禁用或不受浏览器支持。   \n点击“确定”在经典查看器中查看报表。`,
  'EmailUtil.subject.multiple.txt': () => `供审核的报表`,
  'EmailUtil.tooLongEmail.txt': () => `超出电子邮件长度限值。请选择较少的报表发送电子邮件。`,
  'HiddenSectionDialog.close.txt': () => `关闭`,
  'HiddenSectionDialog.export.txt': () => `导出为 PDF`,
  'InfoPanel.information.txt': () => `信息`,
  'InfoPanel.comments.txt': () => `评论`,
  'InfoPanel.alerts.txt': () => `提醒`,
  'IncomingFilters.promptbars.txt': () => `提示栏`,
  'Information.title.txt': () => `标题`,
  'Information.name.txt': () => `名称:`,
  'Information.description.txt': () => `说明:`,
  'Information.displayRules.txt': () => `显示规则:`,
  'Information.graphLevel.txt': () => `图形级别`,
  'Information.reportLevel.txt': () => `报表级别`,
  'Information.legend.txt': () => `图例`,
  'Information.incomingFilters.txt': () => `传入过滤器:`,
  'Information.noIncomingFilters.txt': () => `无传入过滤器`,
  'Information.dataSourceFilters.txt': () => `数据源过滤器:`,
  'Information.interactiveFilters.txt': () => `交互式过滤器:`,
  'MobileContainer.mobileBIMessage.txt': () => `访问移动设备上的 SAS 报表。`,
  'ObjectTypes.report.txt': () => `报表`,
  'ObjectTypes.Report.BI.txt': () => `SAS 报表（2 代）`,
  'ObjectTypes.Report.StoredProcess.txt': () => `存储过程报表`,
  'ObjectTypes.StoredProcess.txt': () => `存储过程`,
  'MissingValues.label.txt': () => `（缺失值）`,
  'PromptContainer.apply.txt': () => `确定`,
  'PromptContainer.cancel.txt': () => `取消`,
  'PromptContainer.close.txt': () => `关闭`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `值必须是介于 ${min} 到 ${max} 之间的数值（包含边界值）。`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `指定一个有效数值。`,
  'TextFieldTypeAhead.validation.string.txt': () => `值对分配的数据无效。`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `输入: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `输入: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `输入 ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min}–${max}`,
  'Slider.missingValues.txt': () => `缺失值`,
  'Slider.missingValues.tooltip.fmt': ({rangeLabel}) => `${rangeLabel}（包括缺失值）`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `后退`,
  'ReportContainer.reportCorrupted.txt': () => `报表已损毁`,
  'ReportContainer.themeLoadFailed.txt': () => `未能加载报表主题。`,
  'ReportContainer.restoreButton.tip.txt': () => `恢复报表`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `报表已恢复`,
  'ReportContainer.renderError.txt': () => `出现错误。无法显示报表。`,
  'ReportContainer.component.renderError.txt': () => `出现错误。无法呈现组件。`,
  'ReportContentPage.open.txt': () => `打开...`,
  'ReportContentPage.refreshReport.txt': () => `刷新报表`,
  'ReportContentPage.editReport.txt': () => `编辑报表`,
  'ReportContentPage.print.txt': () => `打印...`,
  'ReportContentPage.email.txt': () => `电子邮件...`,
  'ReportContentPage.export.txt': () => `导出至 Excel...`,
  'ReportContentPage.reportProperties.txt': () => `报表属性`,
  'ReportContentPage.shareReport.txt': () => `共享报表`,
  'ReportContentPage.enableOverlays.txt': () => `启用对象叠加`,
  'ReportContentPage.disableOverlays.txt': () => `禁用对象叠加`,
  'ReportContentPage.link.txt': () => `链接...`,
  'ReportContentPage.settings.txt': () => `设置...`,
  'ReportContentPage.editPlayback.txt': () => `编辑回放`,
  'ReportContentPage.playReport.txt': () => `播放报表`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `显示带提示的过滤器`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `隐藏带提示的过滤器`,
  'ReportContentPage.reportFilters.txt': () => `报表级别`,
  'ReportContentPage.pageFilters.txt': () => `页面级别`,
  'ReportContentPage.refreshRequired.txt': () => `需要刷新报表`,
  'ReportContentPage.infoButton.tip.txt': () => `信息面板`,
  'ReportContentPage.backButton.tip.txt': () => `查看全部报表`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `更多选项`,
  'ReportContentPage.itemGroupName.txt': () => `报表`,
  'ReportContentPage.maximizeButton.tip.txt': () => `将报表最大化`,
  'ReportContentPage.closeButton.txt': () => `关闭报表`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `报表已最大化`,
  'ReportContentPage.resetReportState.txt': () => `恢复默认报表状态`,
  'ReportContentPage.summary.txt': () => `显示汇总`,
  'ReportManagerPage.objectMenu.open.txt': () => `打开`,
  'ReportManagerPage.objectMenu.edit.txt': () => `编辑`,
  'ReportManagerPage.objectMenu.summary.txt': () => `汇总`,
  'ReportManagerPage.objectMenu.properties.txt': () => `属性`,
  'ReportManagerPage.objectMenu.email.txt': () => `电子邮件...`,
  'ReportManagerPage.objectMenu.print.txt': () => `打印`,
  'ReportManagerPage.browseReportsButton.txt': () => `浏览报表`,
  'ReportManagerPage.newReportButton.txt': () => `新建报表`,
  'ReportManagerPage.emptyView.message.txt': () => `未找到报表。`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `浏览报表`,
  'ReportManagerPage.tableView.name.txt': () => `名称`,
  'ReportManagerPage.tableView.author.txt': () => `作者`,
  'ReportManagerPage.tableView.lastModified.txt': () => `上次修改时间`,
  'ReportManagerPage.openButton.tip.txt': () => `打开报表`,
  'ReportManagerPage.emailButton.tip.txt': () => `通过电子邮件发送报表`,
  'ReportManagerPage.printButton.tip.txt': () => `将报表打印至 PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `报表属性`,
  'ReportObject.multipleReferences.error.txt': () => `报表对象不能在多个上下文中使用。`,
  'ReportObject.notFound.error.txt': () => `无法在指定报表中找到对象名称。`,
  'ReportObject.invalidPage.error.txt': () => `指定的页无效。`,
  'ReportPropertiesDialog.open.txt': () => `打开`,
  'ReportPropertiesDialog.close.txt': () => `关闭`,
  'ReportPropertiesDialog.name.txt': () => `名称:`,
  'ReportPropertiesDialog.description.txt': () => `说明:`,
  'ReportPropertiesDialog.keywords.txt': () => `关键字:`,
  'ReportPropertiesDialog.type.txt': () => `类型:`,
  'ReportPropertiesDialog.location.txt': () => `位置:`,
  'ReportPropertiesDialog.createdBy.txt': () => `创建者:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `创建日期:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `修改者:`,
  'ReportPropertiesDialog.dateModified.txt': () => `修改日期:`,
  'ReportSections.newPageButton.txt': () => `新建页面`,
  'ReportSections.closeTab.tooltip.txt': () => `删除页面`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `“${label}”菜单`,
  'ReportSummaryDialog.title.txt': () => `汇总`,
  'ReportSummaryDialog.open.txt': () => `打开`,
  'ReportSummaryDialog.cancel.txt': () => `取消`,
  'ReportSummaryDialog.close.txt': () => `关闭`,
  'ReportSummaryDialog.noSummary.txt': () => `没有可用的汇总。`,
  'ReportTileBody.modifiedBy.txt': () => `修改者:`,
  'ReportTileBody.lastModified.txt': () => `上次修改时间:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS 报表查看器`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `报表刷新`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `报表自动刷新`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `在以下时间（分钟）后检查更新:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `提醒通知`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `选择默认提醒通知:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `发送电子邮件消息`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `发送 SMS 文本消息`,
  'VAViewerSettingsProvider.alert.system.txt': () => `管理员默认`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `主题`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `覆盖报表主题并使用 SAS High Contrast 报表主题`,
  'ViewerBusyDialog.openReport.txt': () => `正在打开报表...`,
  'ViewerBusyDialog.prepareExport.txt': () => `正在准备导出...`,
  'ViewerBusyDialog.preparePrint.txt': () => `正在准备打印...`,
  'PDFGeneration.printingReport.txt': () => `正在生成报表 PDF。就绪时将会下载。`,
  'PDFGeneration.fileName.fmt': ({date, fileName}) => `${date}生成的“${fileName}”`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `选择一个操作`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `您已达到该层次的最低级别。`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `您已达到所有层次的最低级别。`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `下钻至“${value}”`,
  'SaveImageUtil.snapshot.fmt': ({a1, a2, a0}) => `${a1} ${a2}捕获的“${a0}”快照`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `保存图像`,
  'ObjectToolbarIcon.PrintObject.txt': () => `打印对象...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `共享对象...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `更多`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `“${label}”的对象菜单`,
  'ObjectToolbarIcon.Accelerator.txt': () => `使用 SAS® Graphics Accelerator 查看`,
  'ZoomControl.button.tip.txt': () => `缩放`,
  'ZoomControl.button.zoomin.txt': () => `放大`,
  'ZoomControl.button.zoomout.txt': () => `缩小`,
  'ZoomControl.button.display.txt': () => `缩放控件`,
  'ZoomControl.button.reset.txt': () => `重置缩放`,
  'ExpandControl.button.expand.txt': () => `最大化视图`,
  'ExpandControl.button.restore.txt': () => `恢复视图`,
  'ExpandControl.button.expand.tip.txt': () => `最大化`,
  'ExpandControl.button.restore.tip.txt': () => `恢复`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `该对象最大化时，无法执行页面链接。`,
  'DragModeControl.button.pan.tip.txt': () => `平移`,
  'DragModeControl.button.circular.tip.txt': () => `圆形选择`,
  'DragModeControl.button.freeform.tip.txt': () => `自由选择`,
  'DragModeControl.button.rectangular.tip.txt': () => `矩形选择`,
  'DragModeControl.button.zoom.tip.txt': () => `缩放矩形`,
  'ReportXMLDialog.title.txt': () => `报表 XML`,
  'ReportXMLDialog.closeButton.txt': () => `关闭`,
  'ReportXMLDialog.copyButton.txt': () => `复制到剪贴板`,
  'ReportXMLDialog.error.txt': () => `加载报表 XML 时出错`,
  'ErrorDialog.error.txt': () => `出现错误。请与您的系统管理员联系。`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - 报表查看器`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `打开报表`,
  'OpenReportDialog.reports.txt': () => `报表:`,
  'OpenReportDialog.cancel.txt': () => `取消`,
  'OpenReportDialog.ok.txt': () => `确定`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} 个对象已更新`,
  'AriaLive.oneObjectUpdated.txt': () => `1 个对象已更新`,
  'AriaLive.reportOpened.txt': () => `报表已打开`,
  'AriaLive.reportClosed.txt': () => `报表已关闭`,
  'ExportData.generating.txt': () => `正在生成导出。就绪时将会下载。`,
  'ExportData.warning.txt': () => `生成数据时出错`,
  'ExportData.nodata.txt': () => `没有要导出的数据`,
  'ExportData.exportData.txt': () => `导出数据...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `保存`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `取消`,
  'PlaybackAnimationDialog.playButton.txt': () => `播放报表`,
  'PlaybackAnimationDialog.title.txt': () => `编辑回放`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `过渡单元:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `页`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `对象`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `每单元秒数:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `显示最大化的对象:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `仅显示绘制区:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `显示计时器:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `在点击或触摸时显示导航控件:`,
  'PlaybackNavigationControls.previousPage.txt': () => `上一页`,
  'PlaybackNavigationControls.nextPage.txt': () => `下一页`,
  'PlaybackNavigationControls.previousObject.txt': () => `上一个对象`,
  'PlaybackNavigationControls.nextObject.txt': () => `下一个对象`,
  'TransportConnection.generateReportTimeout.txt': () => `报表加载需要花费较长时间。是否要继续？`,
  'TransportConnection.openReport.txt': () => `打开报表`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `在以下位置指定的报表不存在: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `展开“${label}”`,
  'Hierarchy.collapse.fmt': ({label}) => `折叠“${label}”`,
  'GraphElementDecorator.overview.txt': () => `概览`,
  'GraphElementDecorator.layers.txt': () => `隐藏或显示层`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `隐藏概览`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `显示概览`,
  'TitleInfoButton.tooltip.txt': () => `信息`,
  'SectionSelectionBar.noSelections.txt': () => `无选择项`,
  'SectionSelectionBar.title.txt': () => `过滤器:`,
  'CheckboxList.selectAll.txt': () => `全选`,
  'CheckboxList.clearSelection.txt': () => `清除选择`,
  'CheckboxList.clearSelection.fmt': ({count}) => `清除选择 (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `解释“${label}”`,
  'ExplanationInfoDialog.loading.txt': () => `正在准备解释...`,
  'ExplanationInfoDialog.cancel.txt': () => `取消`,
  'ExplanationInfoDialog.close.txt': () => `关闭`,
  'PromptHeader.emptyReport.txt': () => `将数据项或控件拖动到此处以创建报表提示。`,
  'PromptHeader.emptyPage.txt': () => `将数据项或控件拖动到此处以创建页面提示。`,
  'PromptHeader.collapsePageControlArea.txt': () => `折叠页面控件区域`,
  'PromptHeader.expandPageControlArea.txt': () => `展开页面控件区域`,
  'PromptHeader.collapseReportControlArea.txt': () => `折叠报表控件区域`,
  'PromptHeader.expandReportControlArea.txt': () => `展开报表控件区域`,
  'PromptHeader.collapseControlArea.txt': () => `折叠控件区域`,
  'PromptHeader.expandControlArea.txt': () => `展开控件区域`,
  'PromptHeader.reportControlArea.txt': () => `报表控件区域`,
  'PromptHeader.allControlAreas.txt': () => `全部控件区域`,
  'PromptHeader.pageControlArea.txt': () => `页面控件区域`,
  'ZeroState.editMode.txt': () => `将模板、数据项或对象拖到此处。`,
  'ZeroState.viewMode.txt': () => `没有要显示的内容。`,
  'ObjectStatus.assignData.txt': () => `分配数据`,
  'ObjectStatus.selectImage.txt': () => `选择图像`,
  'ObjectStatus.selectJob.txt': () => `选择作业`,
  'ObjectStatus.cancelLoading.txt': () => `取消加载`,
  'ObjectStatus.loadingCanceled.txt': () => `加载已取消`,
  'ObjectStatus.resumeLoading.txt': () => `恢复加载`,
  'ObjectStatus.refresh.txt': () => `刷新`,
  'ObjectStatus.setJobParameters.txt': () => `设置参数值`,
  'ObjectSearch.title.txt': () => `地理位置搜索`,
  'ObjectSearch.pin.txt': () => `固定`,
  'ObjectSearch.unpin.txt': () => `取消固定`,
  'MainSearchPanel.searchHints.txt': () => `搜索提示`,
  'MainSearchPanel.searchResults.txt': () => `搜索结果`,
  'MainSearchPanel.features.txt': () => `功能`,
  'MainSearchPanel.pin.txt': () => `新建图钉`,
  'MainSearchPanel.pin.tooltip.txt': () => `新建图钉`,
  'MainSearchPanel.route.txt': () => `新建路线`,
  'MainSearchPanel.route.tooltip.txt': () => `新建路线`,
  'MainSearchPanel.geographicArea.txt': () => `新建地理位置范围`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `新建地理位置范围`,
  'MainSearchPanel.newMyLocationPin.txt': () => `我的位置图钉`,
  'MainSearchPanel.myLocationPin.txt': () => `我的位置`,
  'MainSearchPanel.show.txt': () => `显示`,
  'MainSearchPanel.show.all.txt': () => `全部显示`,
  'MainSearchPanel.hide.txt': () => `隐藏`,
  'MainSearchPanel.hide.all.txt': () => `全部隐藏`,
  'MainSearchPanel.delete.txt': () => `删除`,
  'MainSearchPanel.delete.all.txt': () => `全部删除`,
  'MainSearchPanel.convert.txt': () => `将搜索结果转换为图钉`,
  'MainSearchPanel.convert.all.txt': () => `将全部搜索结果转换为图钉`,
  'MainSearchPanel.showPinLabels.txt': () => `显示图钉标签`,
  'MainSearchPanel.close.label.txt': () => `地理位置搜索`,
  'MainSearchPanel.navigate.tooltip.txt': () => `显示详细信息`,
  'MainSearchPanel.demographics.tooltip.txt': () => `人口统计数据`,
  'PanelHeader.back.tooltip.txt': () => `后退`,
  'GeographicAreaPanel.title.txt': () => `地理位置范围`,
  'GeographicAreaPanel.draw.txt': () => `绘制范围`,
  'GeographicAreaPanel.update.txt': () => `更新范围`,
  'GeographicAreaPanel.label.txt': () => `标签:`,
  'GeographicAreaPanel.location.txt': () => `位置:`,
  'GeographicAreaPanel.distance.miles.txt': () => `距离（英里）:`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `距离（公里）:`,
  'GeographicAreaPanel.distance.add.txt': () => `添加距离`,
  'GeographicAreaPanel.time.add.txt': () => `添加时间`,
  'GeographicAreaPanel.distance.delete.txt': () => `删除距离`,
  'GeographicAreaPanel.time.minutes.txt': () => `时间（分钟）:`,
  'GeographicAreaPanel.duration.txt': () => `持续时间:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `英里`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `公里`,
  'GeographicAreaPanel.menu.clear.txt': () => `清除地理位置范围`,
  'GeographicAreaPanel.menu.link.txt': () => `默认将地址链接到数据元素和图钉`,
  'GeographicAreaPanel.menu.unlink.txt': () => `取消链接地理位置范围地址`,
  'GeographicAreaPanel.menu.delete.txt': () => `删除地理位置范围`,
  'GeographicAreaPanel.demographics.txt': () => `人口统计数据`,
  'GeographicAreaPanel.demographics.set.txt': () => `显示人口统计数据`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `展开视图`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `编辑人口统计数据`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `删除人口统计数据`,
  'GeographicAreaPanel.demographics.expired.txt': () => `人口统计数据必须重新加载`,
  'GeographicAreaPanel.demographics.reload.txt': () => `重新加载人口统计数据`,
  'GeographicAreaPanel.invalid.location.txt': () => `地理位置范围没有有效的位置，无法创建。`,
  'TravelTypeField.dateselector.tooltip.txt': () => `选择日期和时间`,
  'TravelTypeField.cancel.txt': () => `取消`,
  'TravelTypeField.ok.txt': () => `确定`,
  'TravelTypeField.button.tooltip.txt': () => `选择日期和时间`,
  'TravelTypeField.day.txt': () => `日期:`,
  'TravelTypeField.time.txt': () => `时间:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `直线`,
  'TravelTypeField.distanceTypes.distance.txt': () => `距离`,
  'TravelTypeField.travelType.txt': () => `出行方式:`,
  'TravelTypeField.traffic.txt': () => `包括路况:`,
  'TravelTypeField.traffic.offset.txt': () => `路况时间偏移量:`,
  'TravelTypeField.traffic.daytime.txt': () => `路况日期和时间:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `距离单位`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `驾驶距离`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `驾驶时间`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `卡车驾驶距离`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `卡车驾驶时间`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `步行距离`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `步行时间`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `无`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `当前路况`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `正常路况`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} 小时`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `更新该地图项的路况`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `更新所有地图项的路况`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `更新路况数据`,
  'RoutePanel.title.txt': () => `路线`,
  'RoutePanel.draw.txt': () => `绘制路线`,
  'RoutePanel.update.txt': () => `更新路线`,
  'RoutePanel.label.txt': () => `标签:`,
  'RoutePanel.locations.txt': () => `位置`,
  'RoutePanel.menu.clear.txt': () => `清除路线`,
  'RoutePanel.menu.reverse.txt': () => `反转路线`,
  'RoutePanel.menu.add.waypoint.txt': () => `添加路线位置`,
  'RoutePanel.menu.delete.waypoint.txt': () => `删除路线位置`,
  'RoutePanel.menu.unlink.txt': () => `取消链接路线位置`,
  'RoutePanel.menu.arrows.txt': () => `路线箭头`,
  'RoutePanel.menu.arrows.hide.txt': () => `隐藏路线箭头`,
  'RoutePanel.menu.arrows.show.txt': () => `显示路线箭头`,
  'RoutePanel.menu.arrows.oneway.txt': () => `单向`,
  'RoutePanel.menu.arrows.twoway.txt': () => `双向`,
  'RoutePanel.menu.delete.txt': () => `删除路线`,
  'RoutePanel.route.width.txt': () => `路线宽度`,
  'RoutePanel.distance.txt': () => `距离:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} 英里`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} 公里`,
  'RoutePanel.location.add.txt': () => `添加位置`,
  'RoutePanel.location.delete.txt': () => `删除位置`,
  'RoutePanel.duration.txt': () => `时间:`,
  'RoutePanel.invalid.location.txt': () => `路线具有无效的位置，无法创建。`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `位置 ${index}，${location}，输入`,
  'PinPanel.pinTitle.txt': () => `图钉`,
  'PinPanel.addDescription.txt': () => `添加说明`,
  'PinPanel.deleteDescription.txt': () => `删除说明`,
  'PinPanel.newPin.txt': () => `在该位置新建图钉`,
  'PinPanel.deletePin.txt': () => `删除图钉`,
  'PinPanel.linkPins.txt': () => `默认将图钉链接到元素`,
  'PinPanel.unlinkAllItems.txt': () => `取消链接全部项`,
  'PinPanel.unlinkItems.txt': () => `取消链接项`,
  'PinPanel.label.txt': () => `标签:`,
  'PinPanel.location.txt': () => `位置:`,
  'PinPanel.description.txt': () => `说明:`,
  'PinPanel.linked.txt': () => `已链接`,
  'PinPanel.searchClickPlaceholder.txt': () => `在地图上搜索或选择`,
  'PinPanel.searchPlaceholder.txt': () => `搜索`,
  'PinPanel.addRoute.txt': () => `添加路线`,
  'PinPanel.addRoute.tooltip.txt': () => `添加路线`,
  'PinPanel.addArea.txt': () => `添加地理位置范围`,
  'PinPanel.addArea.tooltip.txt': () => `添加地理位置范围`,
  'PinPanel.addArea.title.txt': () => `添加地理位置范围`,
  'PinPanel.myLocationTitle.txt': () => `我的位置图钉`,
  'PinPanel.deleteMyLocationPin.txt': () => `删除我的位置图钉`,
  'PinPanel.enableAutoUpdate.txt': () => `启用我的位置自动更新`,
  'PinPanel.disableAutoUpdate.txt': () => `禁用我的位置自动更新`,
  'PinPanel.editAutoRefreshInterval.txt': () => `编辑我的位置自动刷新时间间隔...`,
  'PinPanel.linkToPin.txt': () => `链接至图钉`,
  'PinPanel.useCurrentLocation.txt': () => `使用当前图钉位置`,
  'PinPanel.notDrawn.txt': () => `未绘制`,
  'PinPanel.undetermined.txt': () => `不确定`,
  'PinPanel.findMyLocation.txt': () => `查找我的位置`,
  'PinPanel.cannotDetermineLocation.txt': () => `应用程序无法确定当前位置。若您要共享位置，请参见您的浏览器或设备的帮助。`,
  'PinPanel.autoRefreshInterval.txt': () => `我的位置自动刷新时间间隔`,
  'PinPanel.interval.hours.txt': () => `小时:`,
  'PinPanel.interval.minutes.txt': () => `分钟:`,
  'PinPanel.interval.seconds.txt': () => `秒:`,
  'PinPanel.invalid.location.txt': () => `图钉没有有效的位置，无法创建。`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} 英里`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}、${value2} 英里`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}、${value2}、${value3} 英里`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} 公里`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}、 ${value2} 公里`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}、${value2}、${value3} 公里`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} 分钟`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}、${value2} 分钟`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}、${value2}、${value3} 分钟`,
  'PinPanel.clearLocation.tooltip.txt': () => `清除位置文本`,
  'DiscardChangesDialog.title.area.txt': () => `地理位置范围`,
  'DiscardChangesDialog.title.route.txt': () => `路线`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `您对地理位置范围进行了更改，但没有重新绘制该范围。\n\n是否要放弃对“${label}”的更改？`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `您对地理位置路线进行了更改，但没有重新绘制该路线。\n\n是否要放弃对“${label}”的更改？`,
  'DiscardChangesDialog.discard.txt': () => `放弃`,
  'DiscardChangesDialog.cancel.txt': () => `取消`,
  'FeatureErrorDialog.title.area.txt': () => `绘制地理位置范围`,
  'FeatureErrorDialog.title.route.txt': () => `绘制路线`,
  'FeatureErrorDialog.text.area.txt': () => `无法绘制地理位置范围。\n\n提示: 若您的范围的所在位置不包含道路等基础设施，则可能无法计算地理位置范围。请改用距离出行方式，或将范围移动到具有出行基础设施的位置。`,
  'FeatureErrorDialog.text.route.txt': () => `无法绘制路线。\n\n提示: 若您的路线的所在位置不包含道路等基础设施，则可能无法计算路线。请改用距离出行方式，或将路线移动到具有出行基础设施的位置。`,
  'FeatureErrorDialog.close.txt': () => `关闭`,
  'DemographicsSelectorDialog.title.txt': () => `显示人口统计数据`,
  'DemographicsSelectorDialog.cancel.txt': () => `取消`,
  'DemographicsSelectorDialog.ok.txt': () => `确定`,
  'DemographicsSelectorDialog.country.txt': () => `国家/地区`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `基本`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `高级`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `最近使用`,
  'DemographicsSelectorDialog.categories.txt': () => `类别`,
  'DemographicsSelectorDialog.category.income.txt': () => `收入`,
  'DemographicsSelectorDialog.category.age.txt': () => `年龄`,
  'DemographicsSelectorDialog.category.households.txt': () => `家庭`,
  'DemographicsSelectorDialog.category.housing.txt': () => `住房`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `婚姻状态`,
  'DemographicsSelectorDialog.category.population.txt': () => `人口`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `用户组`,
  'DemographicsSelectorDialog.category.health.txt': () => `健康`,
  'DemographicsSelectorDialog.category.education.txt': () => `教育`,
  'DemographicsSelectorDialog.category.business.txt': () => `商业`,
  'DemographicsSelectorDialog.category.race.txt': () => `人种`,
  'DemographicsSelectorDialog.category.spending.txt': () => `支出`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `行为`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `职业`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `贫困`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `挂毯`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `有风险`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `关键事实`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `供给和需求`,
  'DemographicsSelectorDialog.category.policy.txt': () => `政策`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `横向`,
  'DemographicsSelectorDialog.category.crime.txt': () => `犯罪`,
  'ManageColumns.title.txt': () => `管理列`,
  'ManageColumns.ok.txt': () => `确定`,
  'ManageColumns.cancel.txt': () => `取消`,
  'ManageColumns.hiddenColumns.txt': () => `隐藏的列`,
  'ManageColumns.displayedColumns.txt': () => `显示的列`,
  'SearchResultPanel.title.txt': () => `搜索结果`,
  'SearchResultPanel.menu.delete.txt': () => `删除搜索结果`,
  'SearchResultPanel.convert.txt': () => `转换为图钉`,
  'SearchResultPanel.convert.tooltip.txt': () => `转换为图钉`,
  'DemographicsResultsDialog.title.txt': () => `人口统计数据`,
  'DemographicsResultsDialog.cancel.txt': () => `取消`,
  'DemographicsResultsDialog.close.txt': () => `关闭`,
  'DemographicsResultsDialog.edit.txt': () => `编辑`,
  'DemographicsResultsDialog.layout.page.txt': () => `转盘视图`,
  'DemographicsResultsDialog.layout.list.txt': () => `单列视图`,
  'DemographicsResultsDialog.layout.tile.txt': () => `拼块视图`,
  'DemographicsResultsDialog.noData.txt': () => `没有匹配当前地理位置范围的数据。`,
  'PinsAtSameLocationPanel.title.txt': () => `相同位置的图钉`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `搜索结果`,
  'PinsAtSameLocationPanel.pins.txt': () => `图钉`,
  'PinsAtSameLocationPanel.showAll.txt': () => `全部显示`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `全部隐藏`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `全部删除`,
  'PinsAtSameLocationPanel.show.txt': () => `显示`,
  'PinsAtSameLocationPanel.hide.txt': () => `隐藏`,
  'PinsAtSameLocationPanel.delete.txt': () => `删除`,
  'LocationPopover.pin.title.txt': () => `图钉位置`,
  'LocationPopover.area.title.txt': () => `地理范围位置`,
  'LocationPopover.route.title.txt': ({label}) => `路线位置 ${label}`,
  'LocationPopover.name.txt': () => `名称`,
  'LocationPopover.location.txt': () => `位置:`,
  'LocationPopover.ok.txt': () => `设置位置`,
  'LocationPopover.cancel.txt': () => `退出选择模式`,
  'LocationPopover.hint.txt': () => `再次点击该地图以标识不同的位置。`,
  'TreeDualSelector.source.default.txt': () => `可用项`,
  'TreeDualSelector.target.default.txt': () => `选定项`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength}/${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `无项`,
  'TreeDualSelector.filter.placeholder.txt': () => `过滤`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `自定义项`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `已添加 ${noOfSelectedRows} 项`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `已删除 ${noOfSelectedRows} 项`,
  'TreeDualSelector.afterAction.addAll.txt': () => `已添加全部项`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `已删除全部项`,
  'TreeDualSelector.afterAction.up.txt': () => `上移`,
  'TreeDualSelector.afterAction.down.txt': () => `下移`,
  'TreeDualSelector.afterAction.top.txt': () => `移至顶部`,
  'TreeDualSelector.afterAction.bottom.txt': () => `移至底部`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `已撤销添加操作`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `已撤销移除操作`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `已添加自定义项`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `已选择 ${customItemSelected} 自定义项`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `已选择 ${itemSelected} ${itemDescription}`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `已选择 ${itemSelected}`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `在 ${targetListLabel} 中上移一行`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `在 ${targetListLabel} 中下移一行`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `移至 ${targetListLabel} 的顶部`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `移至 ${targetListLabel} 的底部`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `将项添加至 ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `全部添加至 ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `从 ${targetListLabel} 中移除项`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `从 ${targetListLabel} 中全部移除`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `为 ${targetListLabel} 撤销添加`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `为 ${targetListLabel} 撤销移除`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `过滤 ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `移除`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `若继续操作，您选择要删除的所有自定义项将永久删除。\n\n 是否要继续？`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `移除全部项`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `若继续操作，该列表中的自定义项将永久删除。\n\n 是否要继续？`,
  'LinkNavigator.backButton.label': () => `后退`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `传入过滤器`,
  'LinkNavigator.reportLevel.label': () => `报表级别`,
  'LinkNavigator.sectionLevel.label': () => `页面级别`,
  'ReportSectionZeroState.heading.label': () => `设计报表`,
  'ReportSectionZeroState.description.label': () => `将对象或数据项拖到页面，或者选择下面的选项。`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `将对象或数据项拖到页面，或者从页面模板开始。`,
  'ReportSectionZeroState.autoChartButton.label': () => `生成对象`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `选择模板`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `探索建议`,
  'PromptContainerTooltip.noSelections.txt': () => `无选择项`,
  'PromptContainerTooltip.selectedValues.txt': () => `选定的值`,
}
export default localizers;
